import { Pipe, PipeTransform } from '@angular/core';
import { MaterialIcon } from '../media-library/media-library.model';

@Pipe({
  name: 'filterString',
  standalone: false,
})
export class FilterStringPipe implements PipeTransform {
  transform(value: any[], search = ''): any {
    if (!search.trim()) {
      return value;
    }
    return value.filter((item) => {
      if (item && !item.includeGroup) {
        return item.name.toLowerCase().includes(search.toLowerCase());
      }
    });
  }
}

@Pipe({
  name: 'filterStringIncludeGroup',
  standalone: false,
})
export class FilterStringIncludeGroupPipe implements PipeTransform {
  transform(value: any[], search = ''): any {
    return value.filter((item) => {
      if (item.includeGroup) {
        return item.includeGroup.toLowerCase() === search.toLowerCase();
      }
    });
  }
}

@Pipe({
  name: 'filterNameImg',
  standalone: false,
})
export class FilterNameImg implements PipeTransform {
  transform(images: any[], search = ''): any {
    if (!search.trim()) {
      return images;
    }
    return images
      .filter((img) => {
        return img.filename.toLowerCase().includes(search.toLowerCase());
      })
      .sort((a, b) => {
        const aHasTriggerbee = a.filename?.toLowerCase().includes('triggerbee') ? 1 : 0;
        const bHasTriggerbee = b.filename?.toLowerCase().includes('triggerbee') ? 1 : 0;
        return aHasTriggerbee - bHasTriggerbee;
      });
  }
}

@Pipe({
  name: 'filterIcons',
  standalone: false,
})
export class FilterIconsPipe implements PipeTransform {
  transform(icons: MaterialIcon[], searchString: string, displayLimit: number): MaterialIcon[] {
    if (!searchString) {
      return icons.slice(0, displayLimit);
    }
    const lowerCaseSearch = searchString.toLowerCase();
    const tokens = lowerCaseSearch.split(' ').filter((token) => token.length > 0);
    const filtered = icons.filter((icon) => {
      const words = icon.name.toLowerCase().split('_');
      return tokens.every(
        (token) =>
          words.some((word) => word.startsWith(token)) || icon.tags.some((tag) => tag.toLowerCase().startsWith(token)),
      );
    });
    return filtered
      .sort((a, b) => {
        const aNameIs = a.name.toLowerCase() === lowerCaseSearch;
        const bNameIs = b.name.toLowerCase() === lowerCaseSearch;
        const aWords = a.name.toLowerCase().split('_');
        const bWords = b.name.toLowerCase().split('_');
        // Check if every token in the query exists in the icon name
        const aNameWordIs = tokens.every((token) => aWords.some((word) => word === token));
        const bNameWordIs = tokens.every((token) => bWords.some((word) => word === token));
        // Check if the icon name starts with the query
        const aNameStartsWith = a.name.toLowerCase().startsWith(lowerCaseSearch);
        const bNameStartsWith = b.name.toLowerCase().startsWith(lowerCaseSearch);
        // Check if any token in the query matches the start of any word in the icon name
        const aNameWordStartsWith = tokens.some((token) => aWords.some((word) => word.startsWith(token)));
        const bNameWordStartsWith = tokens.some((token) => bWords.some((word) => word.startsWith(token)));
        if (aNameIs && !bNameIs) {
          return -1;
        } else if (!aNameIs && bNameIs) {
          return 1;
        } else if (aNameWordIs && !bNameWordIs) {
          return -1;
        } else if (!aNameWordIs && bNameWordIs) {
          return 1;
        } else if (aNameStartsWith && !bNameStartsWith) {
          return -1;
        } else if (!aNameStartsWith && bNameStartsWith) {
          return 1;
        } else if (aNameWordStartsWith && !bNameWordStartsWith) {
          return -1;
        } else if (!aNameWordStartsWith && bNameWordStartsWith) {
          return 1;
        } else {
          return b.popularity - a.popularity;
        }
      })
      .slice(0, displayLimit);
  }
}
